import React, { useState, useEffect, Fragment, useCallback } from 'react'
import { Card, Row, Col, Form, Modal, Button } from 'react-bootstrap'
import callApi from '../../helpers/callapi'
import config from '../../config'
import { useDispatch } from 'react-redux'
import axios from 'axios'

import Cookies from 'js-cookie'

const { apiAdminGateway = '' } = config

const limit = 20

const BadQR = () => {
  const [badqr, setBadqr] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPage, setTotalPage] = useState(0)
  const [inputPage, setInputPage] = useState(1)
  const [isShowQRDetail, setIsShowQRDetail] = useState(false)
  const dispatch = useDispatch()
  const [dataToSend, setDataToSend] = useState()

  const sendDataToDetail = (item) => {
    setDataToSend(item)
    setIsShowQRDetail(true)
  }

  const downloadBadQr = async () => {
    dispatch({ type: 'loading_show' })
    axios
      .get(`${apiAdminGateway}/api/v1/lotterytemp/imports/failed-record/download`, {
        responseType: 'blob',
        data: null,
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
          'Content-Type': 'application/zip',
        },
      })
      .then((response) => {
        // create file link in browser's memory
        const href = URL.createObjectURL(response.data)

        // create "a" HTML element with href to file & click
        const link = document.createElement('a')
        link.href = href
        link.setAttribute('download', 'badqr.zip') //or any other extension
        document.body.appendChild(link)
        link.click()

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link)
        URL.revokeObjectURL(href)
      })
      .finally(() => {
        dispatch({ type: 'loading_hide' })
      })
  }

  const fetchBadQr = useCallback(
    async (page = 1) => {
      try {
        dispatch({ type: 'loading_show' })

        const response = await callApi({
          fullURL: `${apiAdminGateway}/api/v1/lotterytemp/imports/failed-record?page=${page}&perPage=${limit}`,
          headers: {
            Authorization: `Bearer ${Cookies.get('accessToken')}`,
          },
        })

        const {
          status: { code, description },
          data: { failedLottery, totalPages },
        } = response

        if (code !== 0) {
          throw new Error(description)
        }

        setBadqr(failedLottery)
        setTotalPage(totalPages)
      } catch (err) {
        setBadqr([])
      } finally {
        dispatch({ type: 'loading_hide' })
      }
    },
    [dispatch],
  )

  const onRemoveBadQr = async (id) => {
    setBadqr((state) => state.filter((x) => x.id !== id))

    try {
      dispatch({ type: 'loading_show' })

      const response = await callApi({
        fullURL: `${apiAdminGateway}/api/v1/lotterytemp/imports/failed-record/${id}`,
        method: 'delete',
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })

      const {
        status: { code, description },
      } = response

      if (code !== 0) {
        throw new Error(description)
      }
    } catch (err) {
      console.log(err)
      alert('เกิดข้อผิดพลาด')
    } finally {
      dispatch({ type: 'loading_hide' })
    }
  }

  const submitBadQr = async ({ matrixId, badqrData }) => {
    if (!matrixId) {
      alert('กรุณากรอกข้อมูลให้ครบถ้วน')
      return
    }
    try {
      dispatch({ type: 'loading_show' })

      const response = await callApi({
        fullURL: `${apiAdminGateway}/api/v1/lotterytemp/imports/failed-record/${badqrData.id}`,
        method: 'put',
        body: {
          matrixId,
        },
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })

      const {
        status: { code, description },
      } = response

      if (code !== 0) {
        throw new Error(description)
      }
    } catch (err) {
      console.log(err)
      alert('เกิดข้อผิดพลาด')
    } finally {
      await fetchBadQr(currentPage)
      dispatch({ type: 'loading_hide' })
    }
  }

  useEffect(() => {
    ;(async () => {
      await fetchBadQr(currentPage)
    })()
  }, [currentPage, fetchBadQr])

  // const offset = (currentPage - 1) * limit;
  // const badQr = badqr.slice(offset, currentPage * limit);
  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Bad QR</Card.Title>
        </Card.Header>
        <Card.Body>
          <Button variant="primary light" onClick={downloadBadQr}>
            Download
          </Button>
          <Row>
            {badqr.length > 0 &&
              badqr.map((item, i) => {
                return (
                  <Col key={i} sm={4} lg={3}>
                    <div className="w-100 text-center bg-light p-2 mb-3">
                      <img src={item.imageUrl} alt={'lottery'} width="100%" />
                      <h5 className="my-2">{`${item.sourcePrimaryFolder}/${item.sourceFolder}/${item.sourceFile}`}</h5>
                      <div className="d-flex justify-content-center">
                        <Button variant="danger light w-100 rounded-0" onClick={() => onRemoveBadQr(item.id)}>
                          ลบ
                        </Button>
                        <Button variant="info light w-100 rounded-0" onClick={() => sendDataToDetail(item)}>
                          แสดง
                        </Button>
                      </div>
                    </div>
                  </Col>
                )
              })}
          </Row>
          {isShowQRDetail && (
            <BadQrForm
              isShowQRDetail={isShowQRDetail}
              setIsShowQRDetail={setIsShowQRDetail}
              submitBadQr={submitBadQr}
              badqr={dataToSend}
            />
          )}
        </Card.Body>
        {badqr.length > 0 && (
          <Card.Footer>
            <div style={{ textAlign: 'right', marginTop: 15 }}>
              {currentPage > 1 && (
                <Button
                  variant="primary light"
                  onClick={() => {
                    setCurrentPage(currentPage - 1)
                    setInputPage((currentPage - 1).toString())
                  }}
                >
                  {'<'}
                </Button>
              )}
              <input
                value={inputPage}
                autoFocus
                style={{ width: '4rem', borderRadius: '10px' }}
                className="btn btn-primary light mx-3 px-1"
                onChange={(e) => {
                  setInputPage(e.target.value)
                }}
                onKeyPress={(e) => {
                  if (e.key === 'Enter') {
                    const page = parseInt(inputPage)
                    if (page && page > 0 && page <= totalPage) {
                      setCurrentPage(page)
                    }
                  }
                }}
              />{' '}
              จาก {totalPage} หน้า {/* {Math.ceil(badqr.length / 20) > currentPage && ( */}
              {currentPage < totalPage && (
                <Button
                  variant="primary light"
                  onClick={() => {
                    setCurrentPage(currentPage + 1)
                    setInputPage((currentPage + 1).toString())
                  }}
                >
                  {'>'}
                </Button>
              )}
              {/* )} */}
            </div>
          </Card.Footer>
        )}
      </Card>
    </Fragment>
  )
}

const BadQrForm = (props) => {
  const { isShowQRDetail, setIsShowQRDetail, badqr, submitBadQr } = props
  const [input, setInput] = useState('')
  const [year, setYear] = useState('')
  const [roundNo, setRoundNo] = useState('')
  const [seriesNo, setSeriesNo] = useState('')
  const [number, setNumber] = useState('')
  const [bookNo, setBookNo] = useState('')

  useEffect(() => {
    document.querySelector('#firstInput').focus()
  }, [])

  const onSubmit = async () => {
    await submitBadQr({
      matrixId: `${year}-${roundNo}-${seriesNo}-${number}-${bookNo}`,
      badqrData: badqr,
    })
    setIsShowQRDetail(false)
  }

  const onScanQr = async (e) => {
    const id = e.target.value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1')
    await submitBadQr({ matrixId: id, badqrData: badqr })
    setIsShowQRDetail(false)
  }

  return (
    <Fragment>
      <Modal size="xl" show={isShowQRDetail} onHide={() => setIsShowQRDetail(false)}>
        <Modal.Header>
          <h3>สแกน QR</h3>
          <Button variant="" className="close" onClick={() => setIsShowQRDetail(false)}>
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm={6}>
              <img src={badqr.imageUrl} alt="" width="100%" />
            </Col>
            <Col sm={6}>
              <Form.Control
                id="firstInput"
                className="form-control"
                type="text"
                placeholder="สแกนลงที่นี่ ..."
                value={input}
                onKeyPress={(e) => e.key === 'Enter' && onScanQr(e)}
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9.-]/g, '').replace(/(\..*)\./g, '$1')
                  setInput(value)
                }}
              />

              <Form.Control
                type="text"
                placeholder="ปี"
                value={year}
                className="my-3"
                onChange={(e) => setYear(e.target.value)}
              />
              <Form.Control
                type="text"
                placeholder="งวดที่"
                value={roundNo}
                className="my-3"
                onChange={(e) => setRoundNo(e.target.value)}
              />
              <Form.Control
                type="text"
                placeholder="ชุดที่"
                value={seriesNo}
                className="my-3"
                onChange={(e) => setSeriesNo(e.target.value)}
              />
              <Form.Control
                type="text"
                placeholder="หมายเลข"
                value={number}
                className="my-3"
                onChange={(e) => setNumber(e.target.value)}
              />
              <Form.Control
                type="text"
                placeholder="เลขเล่ม"
                value={bookNo}
                className="my-3"
                onChange={(e) => setBookNo(e.target.value)}
              />
              <Button variant="primary light w-100" onClick={onSubmit}>
                ยืนยัน
              </Button>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <div className="text-right w-100">
            <Button variant="danger light w-25" onClick={() => setIsShowQRDetail(false)}>
              ยกเลิก
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </Fragment>
  )
}

export default BadQR
